<template>
    <div>
    
        <h1>Create New Email Template</h1>
    
        <div class="box">
    
          <Errors/>
    
          <form class="form" v-on:submit.prevent="createTemplate">
    
            <EmailTemplateFields />
    
            <div class="form-wrap form-submit">
              <div v-if="this.getLoadStatus">
                <button type="submit" class="button" disabled>Creating...</button>
              </div>
              <div v-else>
                <button type="submit" class="button">Create Template</button>
              </div>
            </div>
    
          </form>
    
        </div>
    
    </div>
    
    </template>
    
    <script>

    import EmailTemplateFields from '@/components/EmailTemplateFields.vue'

    import Errors from '@/components/Errors.vue'

    import {mapGetters} from 'vuex'

    export default {

      name: 'EmailTemplteCreate',

      computed: mapGetters(['getLoadStatus']),

      data () {
        return {
          template: {
            template_handling: 'add',
            template_status:1
          },
          errors: null
        }
      },
      components: {
        EmailTemplateFields,
        Errors
      },
      methods: {
        createTemplate () {
            this.$store.dispatch('setLoadStatus')
            
            let {template_name, nature, template_type, template_slug, template_subject, template_status, template_body_content,selected_doc_types} = this.template;
            
            let templateObject = {
                title : template_name,
                nature: nature,
                type: template_type,
                slug:template_slug,
                subject: template_subject,
                body_content: template_body_content,
                selected_doc_types,
                status : (template_status) ? 1 : 0
            }

            fetch(this.$api + 'email-templates/create', {
                method: 'POST',
                body: JSON.stringify(templateObject),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.errors = response.errors
                if(response.status) {
                    this.$router.push({ name: 'email-template'})
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });
                } else if (response.errors) {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
                this.$store.dispatch('setLoadStatus')
            });
        }
      }
    }
    </script>
    